import { List, CommonCell } from "components";
import React from "react";
import { DateCell } from "@/modules/work/billables/cells";
import { StatusCell } from "@/components/status/cell";
import { getUserFields, getdirectusUserFields } from "components/user/config";
import { AssigneeCell, CreatedCell } from "../_cell";
import TicketsFilters from "./filters";
import HeaderPortal from "components/portal/header-portal";
import { Button } from "ui";
import { Link } from "react-router-dom";

export default function SupportAllTickets() {
  const fields = [
    "id",
    "status",
    "title",
    "type",
    "project.name",
    getUserFields("assigned_to"),
    getdirectusUserFields("user_created"),
    "priority",
    "date_created",
    "due_date",
  ];

  const columns = [
    {
      id: "title",
      header: "Title",
      accessorKey: "title",
      cell: ({ row }) => {
        const title = row.original.title;
        return <div className="w-100">{title}</div>;
      },
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      id: "type",
      header: "Type",
      accessorKey: "type",
      cell: (props) => (
        <CommonCell {...props} collection="tickets" field="type" />
      ),
    },
    {
      id: "priority",
      header: "Priority",
      accessorKey: "priority",
      cell: ({ row }) => {
        const priority = row.original.priority;
        let colorClass = "";
        switch (priority?.toLowerCase()) {
          case "low":
            colorClass = "text-blue-500";
            break;
          case "medium":
            colorClass = "text-yellow-500";
            break;
          case "high":
            colorClass = "text-orange-500";
            break;
          case "urgent":
            colorClass = "text-red-500";
            break;
          default:
            colorClass = "";
        }
        return <span className={`${colorClass} capitalize`}>{priority}</span>;
      },
    },
    {
      id: "user_created",
      header: "Created By",
      accessorKey: "user_created",
      cell: CreatedCell,
    },
    {
      id: "assigned_to",
      header: "Assigned To",
      accessorKey: "assigned_to",
      cell: AssigneeCell,
    },
    {
      id: "due_date",
      header: "Due",
      accessorKey: "due_date",
      sortable: true,
      cell: DateCell,
    },
    {
      id: "date_created",
      header: "Created",
      accessorKey: "date_created",
      sortable: true,
      cell: DateCell,
    },
  ];

  const defaultFilters = {
    status: {
      _neq: "closed",
    },
  };

  return (
    <div>
      <HeaderPortal>
        <Link to="../help">
          <Button>Help</Button>
        </Link>
      </HeaderPortal>
      <List
        title="All Tickets"
        storageKey={"all-tickets"}
        endPoint="tickets"
        filters={defaultFilters}
        columns={columns}
        meta={{ fields }}
        sortBy="date_created"
        href={(item) => `/support/all-tickets/${item.id}`}
        renderFilters={TicketsFilters}
      />
    </div>
  );
}
